//   import React from 'react';
//   import './work.css';
// import readwithus from '../Assets/readwithus.png';
// import hotello from '../Assets/hotello.png';
// import furniture from '../Assets/furniture.png';
// import github from '../Assets/github.png';
// import linkedin from '../Assets/linkedin.png';






// const Work = () => {
//     return (

// <section id='works'>
//     <h2 className='workstitle'>Visit My Projects</h2>
//     <span className='worksdesc'>Some of My Works</span> 
//     <div className="worksimgs">

//   <a
//     href="https://readwithus.vercel.app/"
//     target="_blank"
//     rel="noreferrer"
//     className="workCard"
//   >
//     <img src={readwithus} alt="Readwithus.com" className="worksImg" />
//     <div className="workOverlay">
//       <h3>Read With Us</h3>
//       <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
//     </div>
//   </a>

//   <a
//     href="https://hotelloo.vercel.app/"
//     target="_blank"
//     rel="noreferrer"
//     className="workCard"
//   >
//     <img src={hotello} alt="hotello.com" className="worksImg" />
//     <div className="workOverlay">
//       <h3>Hotello</h3>
//       <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
//     </div>
//   </a>

//   <a
//     href="https://furniture-store-one.vercel.app/"
//     target="_blank"
//     rel="noreferrer"
//     className="workCard"
//   >
//     <img src={furniture} alt="Furniturestore.com" className="worksImg" />
//     <div className="workOverlay">
//       <h3>Furniture Store</h3>
//       <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
//     </div>
//   </a>

// </div>

//     {/* <div className='worksimgs'>

//     <a href="https://readwithus.vercel.app/" target="_blank" rel="noreferrer">
//   <img src={readwithus} alt="Readwithus.com" className="worksImg" />
// </a>
// <a href="https://hotelloo.vercel.app/" target="_blank" rel="noreferrer">
//   <img src={hotello} alt="hotello.com" className="worksImg" />
// </a>

// <a href="https://furniture-store-one.vercel.app/" target="_blank" rel="noreferrer">
//   <img src={furniture} alt="Furniturestore.com" className="worksImg" />
// </a>

//     </div> */}






// <div id='contact'>
//   <h1 className='ContactPageTitle'>Contact Me</h1>
// <span className='ContactDesc'>
//   Please fill out the form below to discuss any work opportunities.</span>
// <form className='contactform'>
//   <input type='text' className='name' placeholder='Your Name'/>
//   <input type='email' className='email' placeholder='Your Email'/>
// <textarea className='msg' name='message' rows="5" placeholder='Your Message'></textarea>
// <button type='submit' value="send" className='submitbtn'>Submit</button>

// <div className='Socialmedia'>
//    <img src={linkedin} alt="Linkedin" className='Link'/>
//    <img src={github} alt="Github" className='Link'/>
// </div>




// </form>
// </div>







// </section>

//     )
//   }

//   export default Work;
  import React from 'react';
import './work.css';

import readwithus from '../Assets/readwithus.png';
import hotello from '../Assets/hotello.png';
import furniture from '../Assets/furniture.png';

import github from '../Assets/github.png';
import linkedin from '../Assets/linkedin.png';

const Work = () => {
  return (
    <section id="works">
      <h2 className="workstitle">Visit My Projects</h2>
      <span className="worksdesc">Some of My Works</span>

      <div className="worksimgs">
        <a
          href="https://readwithus.vercel.app/"
          target="_blank"
          rel="noreferrer"
          className="workCard"
        >
          <img src={readwithus} alt="Read With Us" />
          <div className="workOverlay">
            <h3>Read With Us</h3>
            <p>Vanilla JavaScript.</p>
          </div>
        </a>

        <a
          href="https://hotelloo.vercel.app/"
          target="_blank"
          rel="noreferrer"
          className="workCard"
        >
          <img src={hotello} alt="Hotello" />
          <div className="workOverlay">
            <h3>Hotello</h3>
            <p>Angular.js.</p>
          </div>
        </a>

        <a
          href="https://furniture-store-one.vercel.app/"
          target="_blank"
          rel="noreferrer"
          className="workCard"
        >
          <img src={furniture} alt="Furniture Store" />
          <div className="workOverlay">
            <h3>Furniture Store</h3>
            <p>Next.js.</p>
          </div>
        </a>
      </div>

      <div id="contact">
        <h1 className="ContactPageTitle">Contact Me</h1>
        <span className="ContactDesc">
          Please fill out the form below to discuss any work opportunities.
        </span>

        <form className="contactform">
          <input type="text" className="name" placeholder="Your Name" />
          <input type="email" className="email" placeholder="Your Email" />
          <textarea
            className="msg"
            rows="5"
            placeholder="Your Message"
          ></textarea>
          <button type="submit" className="submitbtn">
            Submit
          </button>

          <div className="Socialmedia">
            <a
              href="https://www.linkedin.com/in/aya-kamal-a05381222/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={linkedin} alt="Linkedin" className="Link" />
            </a>

            <a
              href="https://github.com/Ayakamaleldeeb"
              target="_blank"
              rel="noreferrer"
            >
              <img src={github} alt="Github" className="Link" />
            </a>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Work;
